import { render, staticRenderFns } from "./detailInformationFoodClaim.vue?vue&type=template&id=4dd020fb&"
import script from "./detailInformationFoodClaim.vue?vue&type=script&lang=js&"
export * from "./detailInformationFoodClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports